import React from 'react';
import './PrincipalInvestigator.css';
import professorImage from '../assets/BBM_2.jpg'; // Add actual image

const PrincipalInvestigator = () => {
  const stats = [
    { number: '200+', label: 'Publications' },
    { number: '3', label: 'Technology Licensed' },
    { number: '25+', label: 'Patents' },
    { number: '200+', label: 'Invited Talks' },
    { number: '2', label: 'Start Ups' }
  ];


  const education = [
    {
      degree: 'Post Doctoral Research Associate',
      institution: 'Department of Biomedical Engineering, Tufts University, Boston USA',
      year: '2009-2011'
    },
    {
      degree: 'Ph.D. (Biotechnology)',
      institution: 'Indian Institute of Technology Kharagpur, India',
      year: '2005-2009'
    },
    {
      degree: 'M.Sc. (Biotechnology)',
      institution: 'H.P. University, Shimla, India',
      year: '2003-2005'
    },
    {
      degree: 'B.Sc.',
      institution: 'Presidency College, Calcutta University, Kolkata, India',
      year: '2000-2003'
    }
  ];

  const experience = [
    {
      position: 'Associate Dean, Academics (UG)',
      organization: 'IIT Guwahati',
      period: 'May 2020 - May 2023'
    },
    {
      position: 'Professor',
      organization: 'Department of Biosciences and Bioengineering, IIT Guwahati',
      period: '2019 onwards'
    },
    {
      position: 'Associate Professor',
      organization: 'Department of Biosciences and Bioengineering, IIT Guwahati',
      period: '2015-2019'
    },
    {
      position: 'Assistant Professor',
      organization: 'Department of Biosciences and Bioengineering, IIT Guwahati',
      period: '2012-2015'
    },
    {
      position: 'Assistant Professor (on contract)',
      organization: 'Department of Biosciences and Bioengineering, IIT Guwahati',
      period: '2011-2012'
    }
  ];

  const majorAwards = [
    { year: '2026', title: 'National Academy of Sciences, India (NASI) Fellowship', org: 'The National Academy of Sciences, India' },
    { year: '2021', title: 'S. Ramachandran NATIONAL BIOSCIENCE AWARD for Career Development', org: 'Department of Biotechnology, Govt of India' },
    { year: '2020', title: 'SWARNAJAYANTI Fellowship in Life Science', org: 'Department of Science and Technology, Govt of India' },
    { year: '2020', title: 'World Top 2% Scientist List', org: 'Stanford University USA' },
    { year: '2019', title: '3D PRINTING WORLD AWARDS', org: 'Innovator in Tissue Engineering of the year - Medical' },
    { year: '2018', title: 'B.M. BIRLA SCIENCE PRIZE in Biology', org: 'Citation and cash award' },
    { year: '2016', title: 'NASI-SCOPUS Young Scientist Award in Medicine', org: 'The National Academy of Sciences India' },
    { year: '2015', title: 'INSA-MEDAL for Young Scientist', org: 'The Indian National Science Academy' },
    { year: '2014', title: 'Elected Member of National Academy of Sciences, India (M.N.A.Sc.)', org: '2014 onwards' },
    { year: '2013', title: 'NASI-Young Scientist Platinum Jubilee Award', org: 'The National Academy of Sciences India' }
  ];  

  const courses = [
    'BT-618: Biomaterials (BTech/MTech/PhD)',
    'BT-101: Modern Biology (BTech)',
    'BT-501: Biotechniques (MTech/PhD)',
    'BT-636: Tissue Engineering and Stem Cells (BTech/MTech/PhD)',
    'BT-308: Animal Cell Biotechnology (BTech)',
    'NT-601: Nano Device: Fabrication, Productization and Patent Writing (PhD)'
  ];

  const editorialBoards = [
    { journal: 'Biofabrication', details: 'IF 9.95, IOP publishing UK' },
    { journal: 'Journal of the Indian Institute of Science', details: 'IISC Press and Springer' },
    { journal: 'In vitro Models', details: 'Springer Nature' },
    { journal: 'Biomedical Materials', details: 'IF 3.7, IOP publishing UK' },
    { journal: 'Frontiers in Bioengineering and Biotechnology', details: 'Associate Editor, IF 3.64' },
    { journal: 'Frontiers in Materials', details: 'Associate Editor, IF 2.70' },
    { journal: 'Frontiers in Molecular Biosciences', details: 'Associate Editor, IF 4.1' },
    { journal: 'Journal of Biomaterials Applications', details: 'Associate Editor, IF 2.76, SAGE Journals' }
  ];

  const visitingPositions = [
    { institution: 'University College London (UCL), London, UK', year: '2015' },
    { institution: 'KTH, School of Biotechnology, AlbaNova University Centre, Stockholm, Sweden', year: '2014 & 2016' },
    { institution: 'Gauhati University (GU), Department of Bioengineering and Technology, India', year: '2015' },
    { institution: 'Justus-Liebig University, Gissen, Germany', year: '2014' },
    { institution: 'Nanyang Technological University (NTU), Singapore', year: '2012' },
  ];

  const memberships = [
    { abbr: 'NASI', full: 'National Academy of Sciences India' },
    { abbr: 'SIRMB', full: 'Society for Interdisciplinary Research in Materials and Biology, India (Founding BOG member)' },
    { abbr: 'TERMIS', full: 'Tissue Engineering and Regenerative Medicine International Society' },
    { abbr: 'BMES', full: 'Biomedical Engineering Society, USA' },
    { abbr: 'SBAOI', full: 'Society for Biomaterials and Artificial Organs, India (life member)' },
    { abbr: 'ISNM', full: 'Indian Society of Nanomedicine (Life Member)' },
    { abbr: 'STERMI', full: 'Society for Tissue Engineering and Regenerative Medicine, India (life member)' },
    { abbr: 'APA', full: 'Asian Polymer Association (life member)' },
    { abbr: 'ISCA', full: 'The Indian Science Congress Association (life member)' },
    { abbr: 'BRSI', full: 'The Biotech Research Society of India (life member)' }
  ];

  return (
    <div className="pi-page">
      <div className="pi-container">
        {/* Profile Section */}
        <section className="pi-hero">
          <div className="pi-hero-left">
            <div className="pi-image-wrapper">
              <img src={professorImage} alt="Prof. Biman B. Mandal" className="pi-image" />
              {/* <div className="pi-image-placeholder">
                <span>Professor Photo</span>
              </div> */}
            </div>
            <div className="pi-contact-card">
              <h3>Contact Information</h3>
              <div className="contact-item">
                <span className="contact-label">Email:</span>
                <span className="contact-value">biman.mandal@iitg.ac.in</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">Office:</span>
                <span className="contact-value">Dept. of Biosciences & Bioengineering</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">Location:</span>
                <span className="contact-value">IIT Guwahati, Assam</span>
              </div>
            </div>
          </div>

          <div className="pi-hero-right">
            <span className="pi-label">Principal Investigator</span>
            <h1 className="pi-name">Prof. Biman B. Mandal, <i>FBAO, FNASc</i></h1>
            <p className="pi-designation">Professor</p>
            <p className="pi-awards-title">SwarnaJayanti Fellow & National Bioscience Awardee</p>
            
            <div className="pi-affiliation-card primary">
              <h4>Academic Affiliations</h4>
              <p className="primary-dept">Department of Biosciences and Bioengineering</p>
              <ul className="affiliation-list">
                <li>Associated Faculty: Center for Nanotechnology</li>
                <li>Associated Faculty: School of Health Sciences and Technology</li>
                <li>Indian Institute of Technology Guwahati (IITG), Guwahati, Assam, India</li>
                <li>Adjunct Professor: Faculty of Pharmaceutical Sciences, Chulalongkorn University, Bangkok 10330, Thailand</li>
              </ul>
            </div>

            <div className="pi-affiliation-card secondary">
              <h4>Leadership Roles</h4>
              <ul className="role-list">
                <li>
                  <span className="role-title">Associate Editor:</span>
                  <span>ACS Biomaterials Science and Engineering</span>
                </li>
                <li>
                  <span className="role-title">PMRF Subject Coordinator & Convenor:</span>
                  <span>"Biomedical Engg, Biological Sci and Agricultural Sci."</span>
                </li>
                <li>
                  <span className="role-title">Past President:</span>
                  <span>Society for Tissue Engineering and Regenerative Medicine India (STERMI)</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Statistics Section */}
        <section className="pi-stats">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <span className="stat-number">{stat.number}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </section>


        {/* Education and Experience */}
        <div className="pi-grid-two">
          <section className="pi-section">
            <h2 className="section-title">Educational Qualification</h2>
            <div className="timeline">
              {education.map((edu, index) => (
                <div key={index} className="timeline-item">
                  <span className="timeline-year">{edu.year}</span>
                  <div className="timeline-content">
                    <h4>{edu.degree}</h4>
                    <p>{edu.institution}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="pi-section">
            <h2 className="section-title">Professional Experience</h2>
            <div className="timeline">
              {experience.map((exp, index) => (
                <div key={index} className="timeline-item">
                  <span className="timeline-year">{exp.period}</span>
                  <div className="timeline-content">
                    <h4>{exp.position}</h4>
                    <p>{exp.organization}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* Awards Section */}
        <section className="pi-section awards-section">
          <h2 className="section-title">Major Awards & Achievements</h2>
          <div className="awards-grid">
            {majorAwards.map((award, index) => (
              <div key={index} className="award-card">
                <div className="award-year-badge">{award.year}</div>
                <div className="award-content">
                  <h4>{award.title}</h4>
                  <p>{award.org}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Courses and Editorial Boards */}
        <div className="pi-grid-two">
          <section className="pi-section">
            <h2 className="section-title">Courses Taught</h2>
            <ul className="styled-list">
              {courses.map((course, index) => (
                <li key={index}>{course}</li>
              ))}
            </ul>
          </section>

          <section className="pi-section">
            <h2 className="section-title">Editorial Board Member</h2>
            <div className="editorial-list">
              {editorialBoards.map((board, index) => (
                <div key={index} className="editorial-item">
                  <h4>{board.journal}</h4>
                  <p>{board.details}</p>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* Visiting Faculty */}
        <section className="pi-section">
          <h2 className="section-title">Visiting Faculty Positions</h2>
          <div className="visiting-grid">
            {visitingPositions.map((position, index) => (
              <div key={index} className="visiting-card">
                <div className="visiting-year">{position.year}</div>
                <div className="visiting-institution">{position.institution}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Professional Memberships */}
        <section className="pi-section">
          <h2 className="section-title">Professional Memberships</h2>
          <div className="membership-grid">
            {memberships.map((membership, index) => (
              <div key={index} className="membership-card">
                <span className="membership-abbr">{membership.abbr}</span>
                <span className="membership-full">{membership.full}</span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrincipalInvestigator;